import React from "react";
import { useNavigate, Link } from "react-router-dom";
import styles from "./CorporateTab.module.css";
import ProductHeader from "../ProductHeader/ProductHeader";
import FeaturesList from "../FeaturesList/FeaturesList";
import PreviewItem from "../PreviewItem/PreviewItem";
import CalendarView from "../../assets/corporate-calendar-view.png";
import BidPacket from "../../assets/corporate-bid-packet.png";
import BrowserView from "../../assets/corporate-browser-view.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-solid-svg-icons";
import { StaticRoutes } from "../../pages/routes";

const CorporateTab = () => {
  const navigate = useNavigate();

  const children = (
    <>
      Already a JetSuite crew member with a BidPro account?
      <br />
      Click{" "}
      <Link to="https://apps.apple.com/us/app/bidpro-bidding-for-corporate/id1026199824">
        here
      </Link>{" "}
      to download the app on the App Store.
    </>
  );

  const features = [
    {
      icon: "fa-check",
      header: "Line Hold Status",
      description:
        "View the hold status of each line to get a better idea of which lines you may be awarded – before even submitting your bids.",
    },
    {
      icon: "fa-bell",
      header: "Notifications",
      description:
        "Receive push notifications when new bid packages become available, or when new schedules are awarded.",
    },
    {
      icon: "fa-upload",
      header: "Submit Bids In-App",
      description: "Submit your bids directly to JetSuite in the app.",
    },
    {
      icon: "fa-star",
      header: "View Awarded Schedules",
      description: "Easily view your awarded schedules in the app.",
    },
    {
      icon: "fa-cogs",
      header: "Customization",
      description:
        "Make the app your own by customizing your colors, layout, and list names.",
    },
    {
      icon: "fa-download",
      header: "Updates",
      description:
        "Free updates are frequently released to the App Store with new features and bug fixes.",
    },
  ];

  const carouselImgs = [
    { src: CalendarView, alt: "Calendar View" },
    { src: BidPacket, alt: "Bid Packet View" },
    { src: BrowserView, alt: "Browser View" },
  ];

  const sortLinesChildren = (
    <small className={styles.small}>
      Lists can be sorted by pay, days off, days on, line credit, and fleet.
    </small>
  );

  const previewItemFooter = (
    <>
      Want to learn more?{" "}
      <Link to="https://airlinedata.blob.core.windows.net/corporate/ipad_tutorial.pdf">
        View the JetSuite Tutorial{" "}
        <FontAwesomeIcon
          className={styles.faIcon}
          icon={Icons.faArrowUpRightFromSquare}
        />
      </Link>
    </>
  );

  const onClick = () => {
    navigate(StaticRoutes.Contact);
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerRow}>
        <ProductHeader
          title={"JetSuite"}
          description={
            "BidPro has been working with JetSuite since 2016 to provide advanced bidding solutions to JetSuite crew members."
          }
          children={children}
          img={"corporate-calendar-view.png"}
        />
      </div>
      <div className={styles.row}>
        <FeaturesList features={features} colorBlue={true} />
      </div>
      <div className={styles.row}>
        <PreviewItem
          imgRight={true}
          header={"View Bid Data"}
          description={
            "Bid data is easily viewed in 3 different layouts – the Calendar view, Bid Packet view and Browser view."
          }
          imgs={carouselImgs}
        />
      </div>
      <div className={styles.row}>
        <PreviewItem
          imgRight={false}
          header={"Organize Lines into Lists"}
          description={
            "See some bid lines that you want to eliminate, or that you want to keep an eye on? Organize your bids by separating them into four different lists."
          }
          imgs={[
            {
              src: "corporate-move-line.png",
              alt: "Graphic of moving lines on BidPro Plus! Bidding iPad app",
            },
          ]}
        />
      </div>
      <div className={styles.row}>
        <PreviewItem
          imgRight={true}
          header={"Sort Lines"}
          description={
            "Sorting allows you to quickly organize your lines in a way that works best for you. Each list is sorted individually without affecting your other lists."
          }
          imgs={[
            {
              src: "corporate-sort-criteria.png",
              alt: "Graphic of sorting criteria on BidPro Plus! Bidding iPad app",
            },
          ]}
          children={sortLinesChildren}
        />
      </div>
      <div className={styles.row}>
        <PreviewItem
          imgRight={false}
          header={"Submit Bids to JetSuite"}
          description={
            "Bids are submitted directly to JetSuite within the app. Simply select the name of the list you'd like to submit, then tap the Submit Bids button."
          }
          imgs={[
            {
              src: "corporate-submit-bids.png",
              alt: "Graphic of submitting bids on BidPro Plus! Bidding iPad app",
            },
          ]}
          footer={previewItemFooter}
        />
      </div>
      <div className={styles.contactRow}>
        <h2 className={styles.h2}>
          Interested in our Corporate Bidding package?
        </h2>
      </div>
      <div className={styles.contactRow}>
        <button
          type="submit"
          className="btn btn-rounded btn-primary btn-lg"
          id={styles.button}
          onClick={onClick}
        >
          CONTACT US
        </button>
      </div>
    </div>
  );
};

export default CorporateTab;
